"use client";
import { cn } from "@gigpro/ui/tailwind/cn";
import { ToggleGroup as ToggleGroupPrimitive } from "radix-ui";
import type * as React from "react";

const ToggleGroup = ({ ref, className, ...props }: React.ComponentProps<typeof ToggleGroupPrimitive.Root>) => (
  <ToggleGroupPrimitive.Root
    ref={ref}
    className={cn("inline-flex gap-1 rounded-sm bg-background p-1", className)}
    {...props}
  />
);

ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;

const ToggleGroupItem = ({ ref, className, ...props }: React.ComponentProps<typeof ToggleGroupPrimitive.Item>) => (
  <ToggleGroupPrimitive.Item
    ref={ref}
    className={cn(
      "w-full rounded-sm p-1 text-center text-normal font-semibold text-gray transition-colors disabled:text-medium-gray data-[state=on]:bg-brand data-[state=on]:text-white data-[state=on]:disabled:bg-brand/50 data-[state=on]:disabled:text-light-gray [&>svg]:shrink-0",
      className,
    )}
    {...props}
  />
);

ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;

const ToggleGroupItemUnstyled = ToggleGroupPrimitive.Item;

export { ToggleGroup, ToggleGroupItem, ToggleGroupItemUnstyled };
